<style lang="stylus">
    .ActionModal-mask
        modal-mask()
        .ActionModal-modal
            width 450px
            .ActionModal-container
                padding 30px 20px
                .ActionModal-box
                    height 24px
                    margin-bottom 15px
                    display flex
                    justify-content space-between
                    .ActionModal-title
                        width 35%
                        line-height 24px
                    .ActionModal-contentbox
                        width 65%
                        .contentbox-colorLine
                            display flex
                            justify-content space-between
                            width 100%
                            .colorLine-colorbtn
                                colorbtn()
                                width 32px
                                height 24px
</style>

<template>
    <div class="ActionModal-mask">
        <Dialog class="ActionModal-modal" :title="$t('title')" :isShow="true" :showFooter="true" @ok="confirm" @close="cancel">
            <div class="ActionModal-container">
                <div class="ActionModal-box" v-for="item in displayList">
                    <div class="ActionModal-title">
                        <p>{{ item.transName || item.name }}</p>
                    </div>
                    <div class="ActionModal-contentbox">
                        <Input
                            class="contentbox-input"
                            v-if="['string', 'number', 'duration', 'currency', 'percentage', 'scientific'].includes(typeList[item.type])"
                            v-model="item.displayValue"
                            size="small"
                            style="width: 100%"
                            @on-focus="editLocker('focus', 'inputLocker'), setSelectID(item.id)"
                            @on-blur="
                                editLocker('blur', 'inputLocker', () => {
                                    submitChangeValue();
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                            ref="stringInputBox"
                        />

                        <DatePicker
                            class="contentbox-input"
                            v-if="typeList[item.type] == 'dateTime'"
                            v-model="dateList[item.id]['date']"
                            type="date"
                            size="small"
                            style="width: 49%"
                            @on-change="setDate"
                            @on-open-change="setSelectID(item.id)"
                        ></DatePicker>
                        <TimePicker
                            class="contentbox-input"
                            v-if="typeList[item.type] == 'dateTime'"
                            v-model="dateList[item.id]['time']"
                            type="time"
                            size="small"
                            style="width: 50%"
                            @on-change="setTime"
                            @on-open-change="setSelectID(item.id)"
                        ></TimePicker>

                        <i-select
                            class="contentbox-input"
                            v-if="typeList[item.type] == 'boolean'"
                            v-model="dateList[item.id]['boolean']"
                            style="width: 100%"
                            size="small"
                            @on-change="submitChangeValue()"
                            @on-open-change="setSelectID(item.id)"
                        >
                            <i-option :value="'true'" :label="'true'"></i-option>
                            <i-option :value="'false'" :label="'false'"></i-option>
                        </i-select>

                        <i-select
                            class="contentbox-input"
                            v-if="typeList[item.type] == 'list'"
                            v-model="item.value"
                            style="width: 100%"
                            size="small"
                            @on-change="submitChangeValue()"
                            @on-open-change="setSelectID(item.id)"
                        >
                            <i-option :value="item" :label="item" v-for="(item, index) in listList[item.id]" :key="index"></i-option>
                        </i-select>

                        <div class="contentbox-colorLine" v-if="typeList[item.type] == 'color'">
                            <Input
                                class="contentbox-input"
                                v-model="item.displayValue"
                                size="small"
                                style="width: 80%"
                                @on-focus="editLocker('focus', 'inputLocker'), setSelectID(item.id)"
                                @on-blur="
                                    editLocker('blur', 'inputLocker', () => {
                                        submitChangeValue();
                                    })
                                "
                                @keyup.enter.native="iviewInputBlur($event)"
                                ref="colorInputBox"
                            />
                            <div class="colorLine-colorbtn" @click="showColor($event, item.id)">
                                <div :style="{ backgroundColor: item.displayValue }"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class ActionModal extends Vue {
        @Inject()
        ["iviewInputBlur"];
        selectID: number = 0;
        dateList: object = {};
        listList: object = {};
        inputLocker: boolean = false;
        typeList: Array<string> = [
            "string",
            "number",
            "dateTime",
            "duration",
            "currency",
            "boolean",
            "list",
            "",
            "color",
            "percentage",
            "scientific",
        ];
        setDateList(arr) {
            if (arr.length == 1) {
                // 只有一个输入框时聚焦
                this.$nextTick(() => {
                    if (["string", "number", "duration", "currency", "percentage", "scientific"].includes(this.typeList[arr[0]["type"]])) {
                        let str = this.$refs.stringInputBox[0] as HTMLElement;
                        str.focus();
                    } else if (this.typeList[arr[0]["type"]] == "color") {
                        let col = this.$refs.colorInputBox[0] as HTMLElement;
                        col.focus();
                    }
                });
            }
            for (let i = 0; i < arr.length; ++i) {
                if (this.typeList[arr[i]["type"]] == "dateTime") {
                    let dataArr = arr[i]["value"].split(" ") || [];
                    let obj = {
                        date: dataArr.length > 0 ? dataArr[0] : "",
                        time: dataArr.length > 0 ? dataArr[1] : "",
                    };
                    this.dateList[arr[i]["id"]] = obj;
                } else if (this.typeList[arr[i]["type"]] == "boolean") {
                    this.dateList[arr[i]["id"]] = {
                        boolean: arr[i]["value"].toString(),
                    };
                } else if (this.typeList[arr[i]["type"]] == "list") {
                    let value = [];
                    if (arr[i]["transFormat"]) {
                        value = arr[i]["transFormat"].split(";");
                    } else {
                        value = arr[i]["format"].split(";");
                    }
                    if (arr[i]["format"] == "EDDATEFORMAT") {
                        //  日期格式 特殊处理
                        value = [
                            "yyyy-MM-dd",
                            "yyyy/M/d",
                            "M/d/yyyy",
                            "M/d/yy",
                            "d/M/yyyy",
                            "d/M/yy",
                            "M.d.yyyy",
                            "d.M.yyyy",
                            "yy-M-d",
                            "MM-dd-yy",
                            "MMMM dyyyy",
                            "ddddMMMM ddyyyy",
                            "d MMMM yyyy",
                            "d-MMM-yy",
                            "MMM.dyy",
                            "MMMM yy",
                            "MMM-yy",
                            "yyyy",
                            "MMM",
                            "M/d/yyyy h:mm:ss ap",
                            "M/d/yyyy h:mm ap",
                            "d/M/yyyy h:mm:ss ap",
                            "d/M/yyyy h:mm ap",
                            "h:mm ap",
                            "h:mm:ss ap",
                            "hh:mm",
                            "hh:mm:ss",
                            "hh",
                            "mm",
                            "ss",
                        ];
                    }
                    this.listList[arr[i]["id"]] = value;
                }
            }
        }
        setDate(v) {
            this.submitChangeValue();
        }
        setTime(v) {
            this.submitChangeValue();
        }
        setSelectID(ID) {
            this.selectID = ID;
        }
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        showColor(e, ID) {
            this.selectID = ID;
            let node = e.target;
            let payload = {
                type: this.fmtType.OnceColor,
                index: 10,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "OnceColor" });
            });
        }
        submitChangeValue() {
            for (let i = 0; i < this.actionData.length; ++i) {
                if (this.actionData[i]["id"] == this.selectID) {
                    if (["number", "currency", "duration", "percentage", "scientific"].includes(this.typeList[this.actionData[i]["type"]])) {
                        let data = parseFloat(this.actionData[i]["displayValue"]);
                        if (isNaN(data)) {
                            this.$edMessage.error(this.$t("invalidVal"));
                            return;
                        }
                        this.actionData[i]["value"] = data;
                        if (this.typeList[this.actionData[i]["type"]] == "percentage") {
                            //百分数手动除100
                            this.actionData[i]["value"] /= 100;
                        }
                    } else if (this.typeList[this.actionData[i]["type"]] == "list") {
                        this.actionData[i]["value"] = this.actionData[i]["value"];
                    } else if (this.typeList[this.actionData[i]["type"]] == "boolean") {
                        this.actionData[i]["value"] = this.dateList[this.selectID]["boolean"] == "false" ? false : true;
                    } else if (this.typeList[this.actionData[i]["type"]] == "dateTime") {
                        let date = new Date(this.dateList[this.selectID]["date"]);
                        // let timeArr = this.dateList[this.selectID]['time'].split(':')
                        // date && date.setHours(timeArr[0])
                        // date && date.setMinutes(timeArr[1])
                        // date && date.setSeconds(timeArr[2])
                        let year = date.getFullYear();
                        let month = date.getMonth() + 1;
                        let day = date.getDate();
                        this.actionData[i]["value"] = `${year}/${month}/${day} ${this.dateList[this.selectID]["time"]}`;
                    } else {
                        this.actionData[i]["value"] = this.actionData[i]["displayValue"];
                    }
                }
            }
        }

        confirm() {
            console.log("confirm");
            // this.submitChangeValue();
            // window['_view'].updatePropertyFromAction();
            window["_view"].updateActions(this.actionData);
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        enterConfirm(e) {
            if (e.keyCode == 13) {
                this.submitChangeValue();
                window["_view"].updateActions(this.actionData);
                this.$store.commit("setDialogState", {
                    type: "showDialog",
                    data: false,
                });
            }
        }
        cancel() {
            window["_view"].cancelActions();
        }

        @Watch("onceColor")
        watchColor(val) {
            if (val && /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(val)) {
                for (let i = 0; i < this.actionData.length; ++i) {
                    if (this.actionData[i]["id"] == this.selectID) {
                        this.actionData[i]["displayValue"] = val;
                        this.submitChangeValue();
                    }
                }
            }
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get onceColor() {
            return this.$store.state.ui.onceColor;
        }
        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        get actionData() {
            return this.$store.state.dialog.actionData;
        }
        get displayList() {
            let arr = this.actionData.filter((v, k) => {
                return v.visible;
            });
            this.setDateList(arr);
            return arr;
        }
        set actionData(v) {
            this.$store.commit("setDialogState", {
                type: "actionData",
                data: v,
            });
        }
        mounted() {
            document.addEventListener("keydown", this.enterConfirm);
        }
        beforeDestroy() {
            document.removeEventListener("keydown", this.enterConfirm);
        }
        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "修改动作",
    "libraryName": "库名",
    "confirm": "确定",
    "cancel": "取消",
    "invalidVal": "无效数值"
  },
  "en": {
    "title": "Change Action",
    "libraryName": "Library Name",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "invalidVal": "Invalid value"
  },
  "jp": {
    "title": "アクションを変更",
    "libraryName": "ライブラリ名",
    "confirm": "OK",
    "cancel": "キャンセル",
    "invalidVal": "無効な値"
  },
  "fr": {
    "title": "Modifier l'action",
    "libraryName": "Nom de Bibliothèque",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "invalidVal": "Valeur Invalide"
  },
  "de": {
    "title": "Maßnahme ändern",
    "libraryName": "Bibliotheksname",
    "confirm": "Bestätigen",
    "cancel": "Stornieren",
    "invalidVal": "Ungültige Daten"
  },
  "es": {
    "title": "Acción de cambio",
    "libraryName": "Nombre de la biblioteca",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "invalidVal": "valor no válido"
  },
  "pt": {
    "title": "Alterar Ação",
    "libraryName": "Nome de Biblioteca",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "invalidVal": "Valor Inválido"
  },
  "it": {
    "title": "Modifica Azione",
    "libraryName": "Nome Libreria",
    "confirm": "Conferma",
    "cancel": "Annulla",
    "invalidVal": "Valore non Valido"
  },
  "tw": {
    "title": "修改動作",
    "libraryName": "庫名",
    "confirm": "確定",
    "cancel": "取消",
    "invalidVal": "無效數值"
  },
  "kr": {
    "title": "동작 변경",
    "libraryName": "라이브러리 이름",
    "confirm": "확인 ",
    "cancel": "취소",
    "invalidVal": "잘못된 값"
  }
}
</i18n>
